import moment from 'moment'

export default {
  data () {
    return {}
  },

  filters: {
    date (v) {
      if (!v) return null
      return moment(v).locale('es').format('DD MMM YYYY')
    },

    dateShort (v) {
      if (!v) return null
      return moment(v).locale('es').format('DD/MM/YYYY')
    },

    upper (v) {
      if (v) return v.toUpperCase()
    },

    lower (v) {
      if (v) return v.toLowerCase()
    }
  }
}
